export const CATEGORY_ORDER = [
  'produce',
  'protein',
  'dairy',
  'grains',
  'baking',
  'canned',
  'condiments',
  'oils',
  'spices',
  'nuts',
  'beverage',
  'other',
];

export const CATEGORY_LABEL: Record<string, string> = {
  produce: 'Produce',
  protein: 'Meat & Protein',
  dairy: 'Dairy',
  grains: 'Grains & Bakery',
  baking: 'Baking',
  canned: 'Canned & Jarred',
  condiments: 'Condiments',
  oils: 'Oils & Vinegars',
  spices: 'Spices',
  nuts: 'Nuts & Seeds',
  beverage: 'Beverages',
  other: 'Other',
};

export const CATEGORY_ICON: Record<string, 'leaf' | 'flame' | 'egg' | 'cookpot' | 'plate' | 'cart'> = {
  produce: 'leaf',
  protein: 'flame',
  dairy: 'egg',
  grains: 'cookpot',
  baking: 'cookpot',
  canned: 'plate',
  condiments: 'plate',
  oils: 'plate',
  spices: 'plate',
  nuts: 'leaf',
  beverage: 'plate',
  other: 'cart',
};
